module.exports = __webpack_public_path__ + "img/stop.1619ce40.svg";